import { handleUrl, myHeadersWithTokenContentType } from '../../global';
import {
  CityLocationResponse,
  CoverageDetail,
  NoticeCoverageData,
  PoleLimitsListResponse,
  SingleCoverageData,
  UpdatePoleLimitsData,
  UpdatePoleLimitsResponse,
} from './types';

export const createNoticeCoverage = (
  id: number,
  data: NoticeCoverageData
): Promise<CoverageDetail> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${id}/notice-coverages`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const getNoticeCoverage = (id: number): Promise<CoverageDetail> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${id}/notice-coverages`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const createSingleCoverage = (
  id: number,
  data: SingleCoverageData
): Promise<CoverageDetail> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${id}/notice-coverages/single`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const deleteCoverage = (id: number): Promise<CoverageDetail> => {
  const requestOptions = {
    method: 'DELETE',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/notice-coverages/${id}`, requestOptions)
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const getPoleLimits = (
  id: number,
  page: number,
  size: number
): Promise<PoleLimitsListResponse> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${id}/poles?page=${page}&size=${size}`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const updatePoleLimits = (
  id: number,
  data: UpdatePoleLimitsData
): Promise<UpdatePoleLimitsResponse> => {
  const requestOptions = {
    method: 'PATCH',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/public-notices/${id}/poles/limits`,
    requestOptions
  )
    .then((response) => response.json())
    .catch((error) => new Error(error));
};

export const getCityCoverage = async (
  uf: number
): Promise<CityLocationResponse> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/cities?uf=${uf}&all=true`, requestOptions)
    .then((response) => response.json())
    .catch((error) => new Error(error));
};
